import type { CommandData } from '../types'

export function hidePreviewMessage() {
  const message: CommandData = {
    isFromNetwatch: true,
    command: 'hidePreviewMessage',
  }
  window.postMessage(message)
}
